import { HFBLocation } from "@coworker/app/src/components/RoomSettings/Molecules/HFBLocation";
import { ArticleStock } from "@coworker/app/src/components/RoomSettings/Molecules/ArticleStock";
import { SupplierNumber } from "@coworker/app/src/components/RoomSettings/Molecules/SupplierNumber";
import { DateStamp } from "@coworker/app/src/components/RoomSettings/Molecules/DateStamp";
import { Article } from "@coworker/app/src/components/RoomSettings/types/article";
import { PriceLevel } from "../Molecules/PriceLevel";
import { StyleGroup } from "../Molecules/StyleGroup";

interface AboutItemProps {
  article: Article;
  isFromSearch?: boolean;
}

export const AboutItemSection = ({
  article,
  isFromSearch = false,
}: AboutItemProps) => {
  return (
    <>
      {!isFromSearch && <HFBLocation hfb={article.hfb} />}

      <ArticleStock
        productArticleId={article.productArticleId}
        productArticleType={article.productArticleType}
      />

      {!isFromSearch && (
        <SupplierNumber
          article={article}
          value={article.supplierNumber ?? ""}
        />
      )}

      {!isFromSearch && (
        <DateStamp article={article} value={article.dateStamp ?? ""} />
      )}

      {article.priceLevel ? (
        <PriceLevel priceLevel={article.priceLevel ?? ""} />
      ) : null}

      {article.styleGroup ? (
        <StyleGroup styleGroup={article.styleGroup ?? ""} />
      ) : null}
    </>
  );
};
